import React from "react";
import Modal from "../../../components/general/Modal";
import {
  Container,
  FlowName,
  Footer,
  SubTitle,
  Title,
  DivIcon,
} from "./styles";
import Button from "../../../components/general/Button";
import Close from "../../../assets/icons/Close";
import { usePromiseTracker } from "react-promise-tracker";

//? Exclude Flow Model modal:
//isOpen -> Controlador se o modal está aberto ou não
//onClose -> Função executada ao cancelar/fechar/clicar fora do modal
//onConfirm -> Função executada ao confirmar no modal
//selector -> Local onde o modal sera renderizado(root -> Toda a tela)
//className -> nodrag = modal não pode ser movido
//flowName -> Nome renderizado na tela

const ExcludeFlowModelModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
  flowName,
}) => {
  const { promiseInProgress } = usePromiseTracker({ area: "remove-flow" });

  return (
    <Modal
      isOpen={isOpen}
      selector={selector}
      className={className}
      flowName={flowName}
      onClose={onClose}
    >
      <Container>
        <Title>Excluir modelo de fluxo </Title>
        <SubTitle style={{ color: "red" }}>
          Deseja seguir com a exclusão do Projeto?
        </SubTitle>
        <FlowName>{!promiseInProgress ? flowName : "Aguarde.."}</FlowName>
        <Footer>
          {!promiseInProgress ? (
            <>
              <Button
                outline
                content="Cancelar"
                width={"11.3125rem"}
                height={"2.625rem"}
                onClick={onClose}
              />
              <Button
                content="Sim, excluir"
                width={"11.3125rem"}
                height={"2.625rem"}
                onClick={onConfirm}
              />
            </>
          ) : null}
        </Footer>
        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default ExcludeFlowModelModal;
